module.exports = __webpack_public_path__ + "static/media/hello-kitty.53f71fc6.png";